(function () {
  async function normalizeGifts() {
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      const gifts = cart.items.filter(item => {
        const t = (item.title || '').toLowerCase();
        const pt = (item.product_title || '').toLowerCase();
        return t.includes('gift') || pt.includes('gift');
      });
      if (gifts.length === 0) return;
      if (gifts.length === 1 && gifts[0].quantity === 1) return;
      const keep = gifts[gifts.length - 1];
      const updates = {};
      gifts.forEach(g => {
        updates[g.key] = (g.key === keep.key) ? 1 : 0;
      });
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
      window.location.reload();
    } catch (e) {
      console.error('Gift normalize error:', e);
    }
  }
  window.normalizeGifts = normalizeGifts;
  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url);
    if (url && url.indexOf('/cart/add') > -1) {
      const isGiftPage = window.location.search.indexOf('isGift') > -1
        || (document.querySelector('h1')?.textContent || '').toLowerCase().includes('gift');
      if (isGiftPage) {
        let variantId = null;
        let extractedProperties = {};
        try {
          const options = args[1] || {};
          if (options.body instanceof FormData) {
            variantId = options.body.get('id');
            for (const [key, value] of options.body.entries()) {
              const match = key.match(/^properties\[(.+)\]$/);
              if (match) {
                extractedProperties[match[1]] = value;
              }
            }
          } else if (typeof options.body === 'string') {
            try {
              const parsed = JSON.parse(options.body);
              if (parsed.items && parsed.items[0]) {
                variantId = parsed.items[0].id;
                if (parsed.items[0].properties) {
                  extractedProperties = parsed.items[0].properties;
                }
              }
            } catch (e) {
              const params = new URLSearchParams(options.body);
              variantId = params.get('id');
              for (const [key, value] of params.entries()) {
                const match = key.match(/^properties\[(.+)\]$/);
                if (match) {
                  extractedProperties[match[1]] = value;
                }
              }
            }
          }
        } catch (e) {
          console.warn('Cannot extract variantId:', e);
        }
        if (variantId) {
          const cart = await originalFetch('/cart.js').then(r => r.json());
          const giftKeys = {};
          cart.items.forEach(item => {
            const t = (item.title || '').toLowerCase();
            const pt = (item.product_title || '').toLowerCase();
            if (t.includes('gift') || pt.includes('gift')) {
              giftKeys[item.key] = 0;
            }
          });
          if (Object.keys(giftKeys).length > 0) {
            await originalFetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: giftKeys })
            });
          }
          return originalFetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{ id: parseInt(variantId), quantity: 1, properties: extractedProperties }]
            })
          });
        }
      }
    }
    return originalFetch.apply(this, args);
  };
})();